import env from 'configuration'
import { useAgency } from 'context/agency'
import { AuthInit, useAuth } from 'context/auth'
import { LocationInit } from 'context/location'
import useScript from 'hooks/script'
import { useRoutes } from 'react-router-dom'
import Routes from 'routing/routes'
function App() {
  const routes = useRoutes(Routes())
  const { agency } = useAgency()
  const scriptLoaded = useScript(
    `https://maps.googleapis.com/maps/api/js?key=${env.G_MAP_API_KEY}&loading=async&libraries=places`
  )

  const bg_color = agency?.location_config?.page_bg_color
  return (
    <div
      style={{
        backgroundColor: bg_color,
      }}
      className='h-screen overflow-y-auto relative'
    >
      <AuthInit>
        <LocationInit>{routes}</LocationInit>
      </AuthInit>
    </div>
  )
}

export default App
